import React from 'react';
import styled from 'styled-components';

interface Props {
  text: string;
  animateIn: boolean;
  animationType?: string;
}

const Letter = styled.span`
  display: inline-block;
  transform-origin: bottom;
  transition: transform 0.15s ease-out;
  transform: rotateX(-90deg);
  line-height: 1.5;
`;

const LetterSpace = styled.span`
  display: inline-block;
  width: 25px;
  height: 1px;
`;

const Word = styled.span`
  display: inline-block;
  white-space: nowrap;
  margin: -0.15em 0;
  
  &.show {
    ${Letter} {
      transform: rotateX(0);
    }
  }
`;

export const TextAnimation = (props: Props) => {
  const { text, animateIn } = props;
  let delay: number = -1;

  const _getWordOffsetDelay = (): number => {
    return delay++;
  };

  const _renderWord = (word: string, wordIndex: number): React.ReactNode => {
    let letters: Array<string> = word.split('') || [];

    return (
      <Word key={wordIndex} className={animateIn ? 'show' : ''}>
        <React.Fragment>
          {Array.isArray(letters) && letters.map((letter: string, index: number) =>
            <Letter key={index} style={{transitionDelay: ((_getWordOffsetDelay()) * 0.05) + 's'}}>{letter}</Letter>
          )}
          <LetterSpace />
        </React.Fragment>
      </Word>
    )
  };

  let words: Array<string> = text.split(' ') || [];
  return (
    <span>
    {Array.isArray(words) && words.map((word: string, index: number) =>
      _renderWord(word, index)
    )}
    </span>
  )
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/animation/TextAnimation.tsx